import { useState } from "react";
import PropTypes from "prop-types";
import { Button, Select, Space } from "top-component-library";
import DeactivateCustomerDialog from "./DeactivateCustomerDialog";
import DeleteCustomerDialog from "./DeleteCustomerDialog";
import { DangerLabel, DangerSettingsCard, FormRow, WarningHint } from "../styles";

// Mirrors editCustomerProperties.html's Danger Zone section: legacy wraps a "Super Admin
// Actions" card and a second, unnamed destructive-actions card (its own warning subheader,
// ported below as WarningHint) under one outer "Danger Zone" <h2> - merged into a single
// card here, with Super Admin Actions folded into the title instead of its own card.
const DangerZoneCard = ({
  isBbotAdmin,
  selectedReferrer,
  possibleReferrers,
  switching,
  onChangeReferrer,
  onSwitchReferrer,
  canDelete,
  isArchived,
  canBeReactivated,
  reactivating,
  onDelete,
  onDeactivate,
  onReactivate,
}) => {
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [deactivateDialogVisible, setDeactivateDialogVisible] = useState(false);

  return (
    <DangerSettingsCard title={isBbotAdmin ? "Danger Zone - Super Admin Actions" : "Danger Zone"}>
      <WarningHint>All of the options below should be used with extreme caution. You have been warned.</WarningHint>
      <Space direction="vertical" size="middle">
        {isBbotAdmin && (
          <>
            <FormRow>
              <DangerLabel htmlFor="customer-properties-switch-referrer">Switch Referrer</DangerLabel>
              <Select id="customer-properties-switch-referrer" value={selectedReferrer} onChange={onChangeReferrer}>
                {possibleReferrers.map((referrer) => (
                  <Select.Option key={referrer} value={referrer}>
                    {referrer}
                  </Select.Option>
                ))}
              </Select>
            </FormRow>
            <Button danger loading={switching} disabled={!selectedReferrer} onClick={onSwitchReferrer}>
              Switch Referrer + Admin Team
            </Button>
          </>
        )}
        <Space>
          {canDelete && (
            <Button danger onClick={() => setDeleteDialogVisible(true)}>
              Delete Customer
            </Button>
          )}
          {!isArchived && (
            <Button danger onClick={() => setDeactivateDialogVisible(true)}>
              Deactivate Customer
            </Button>
          )}
          {canBeReactivated && (
            <Button danger loading={reactivating} onClick={onReactivate}>
              Reactivate Customer
            </Button>
          )}
        </Space>
      </Space>
      {deleteDialogVisible && (
        <DeleteCustomerDialog onClose={() => setDeleteDialogVisible(false)} onConfirm={onDelete} />
      )}
      {deactivateDialogVisible && (
        <DeactivateCustomerDialog onClose={() => setDeactivateDialogVisible(false)} onConfirm={onDeactivate} />
      )}
    </DangerSettingsCard>
  );
};

DangerZoneCard.propTypes = {
  isBbotAdmin: PropTypes.bool.isRequired,
  selectedReferrer: PropTypes.string.isRequired,
  possibleReferrers: PropTypes.arrayOf(PropTypes.string).isRequired,
  switching: PropTypes.bool.isRequired,
  onChangeReferrer: PropTypes.func.isRequired,
  onSwitchReferrer: PropTypes.func.isRequired,
  canDelete: PropTypes.bool.isRequired,
  isArchived: PropTypes.bool.isRequired,
  canBeReactivated: PropTypes.bool.isRequired,
  reactivating: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  onReactivate: PropTypes.func.isRequired,
};

export default DangerZoneCard;
